import { useMemo } from "react";
import DataTable from "react-data-table-component";
import { createColumns } from "../../helpers";
import { DATATABLE_CUSTOM_STYLES } from "../../constants/datatableStyles";
import RowLoader from "../UI/RowLoader";
import { convertBooleanValues } from "../../_helper";

const isLoading = false;
const InstructorAssignedCourses = ({
  title,
  data,
  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
}) => {
  const handleData = convertBooleanValues(data, ["isActive"]);
  const hiddenColumns = ["courseId"];

  const columns = useMemo(() => {
    return createColumns(handleData, [], hiddenColumns, true);
  }, [handleData]).map((col) => ({
    ...col,
    sortable: col.name === "Num",
    width: ["Num", "Edit", "Delete", "Details"].includes(col.name)
      ? "70px"
      : "1fr",
  }));
  return (
    <section className={className}>
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>

      <DataTable
        columns={columns}
        data={handleData}
        customStyles={DATATABLE_CUSTOM_STYLES}
        progressPending={isLoading}
        progressComponent={<RowLoader />}
      />
    </section>
  );
};

export default InstructorAssignedCourses;
